if (!customElements.get('doi-entry')) {
  class DoiEntry extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.config = JSON.parse(this.querySelector('[data-entry-config]').textContent);
      this.dialog = this.querySelector('[data-dialog]');
      this.photoIndex = 0;
      const body = this.querySelector('[data-body]');
      this.setupFilms(body,options);
      const headings = [...(this.films.length ? [this.querySelector('.doi-films__heading h2')] : []), ...(body ? [...body.querySelectorAll('h2')].filter(h => !h.closest('details')) : [])];
      if (headings.length > 1) {
        const list = this.querySelector('[data-toc-list]');
        headings.forEach((heading,index) => {
          if (!heading.id) heading.id = `doi-heading-${this.dataset.section}-${index+1}`;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${heading.id}`;
          a.textContent = heading.textContent;
          li.append(a);list.append(li);
        });
        this.querySelector('[data-toc]').hidden = false;
      }
      body?.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('doi-entry__table-scroll')) return;
        const wrapper = document.createElement('div');wrapper.className='doi-entry__table-scroll';wrapper.tabIndex=0;table.before(wrapper);wrapper.append(table);
      });
      if (this.dialog.showModal) {
        this.querySelectorAll('[data-photo]').forEach(link => link.addEventListener('click',event => {
          event.preventDefault();if(this.films?.length)this.selectFilm(this.filmIndex,false);this.opener=link;this.photoIndex=Number(link.dataset.photo);this.showPhoto();this.dialog.showModal();document.documentElement.classList.add('doi-photo-viewer-open');
        },options));
        this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
        this.querySelector('[data-previous]').addEventListener('click',()=>this.changePhoto(-1),options);
        this.querySelector('[data-next]').addEventListener('click',()=>this.changePhoto(1),options);
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},options);
        this.dialog.addEventListener('keydown',event=>{if(this.dialog.classList.contains('doi-entry__dialog--video'))return;if(event.key==='ArrowLeft'){event.preventDefault();this.changePhoto(-1);}if(event.key==='ArrowRight'){event.preventDefault();this.changePhoto(1);}},options);
        this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('doi-photo-viewer-open');this.querySelector('[data-dialog-media]').replaceChildren();this.opener?.focus({preventScroll:true});},options);
      }
      const share=this.querySelector('[data-share]');
      if (navigator.clipboard?.writeText) {
        share.hidden=false;share.addEventListener('click',async()=>{
          const url=document.querySelector('link[rel="canonical"]')?.href || `${location.origin}${location.pathname}`;
          try{await navigator.clipboard.writeText(url);this.querySelector('[data-share-status]').textContent=this.config.copied;}catch{this.querySelector('[data-share-status]').textContent=this.config.copyError;}
        },options);
      }
    }
    setupFilms(body,options) {
      const config=JSON.parse(this.querySelector('[data-film-config]').textContent);
      this.filmLabels=config.labels;
      this.films=[];
      const byKey=new Map();
      const identify=(source)=>{
        try {
          const url=new URL(source,location.href),host=url.hostname.replace(/^www\./,'');
          let id,provider,hash='';
          if(['youtube.com','youtube-nocookie.com','m.youtube.com'].includes(host)){
            provider='youtube';id=url.searchParams.get('v') || url.pathname.match(/^\/(?:embed|shorts|live)\/([^/?]+)/)?.[1];
          } else if(host==='youtu.be'){provider='youtube';id=url.pathname.split('/')[1];}
          else if(['vimeo.com','player.vimeo.com'].includes(host)){provider='vimeo';id=url.pathname.match(/(?:video\/)?(\d+)/)?.[1];hash=url.searchParams.get('h')||'';}
          if(!id || !/^[\w-]+$/.test(id))return null;
          return {host:provider,id,hash,key:`${provider}:${id}`};
        }catch{return null;}
      };
      const add=(film)=>{
        film.key=film.key||`${film.host}:${film.id}`;
        if(byKey.has(film.key))return byKey.get(film.key);
        film.title=film.title?.trim() || `${config.title} · ${this.films.length+1}`;
        film.poster=film.poster || (film.host==='youtube'?`https://i.ytimg.com/vi/${film.id}/hqdefault.jpg`:config.poster);
        film.url=film.host==='youtube'?`https://www.youtube.com/watch?v=${film.id}`:film.host==='vimeo'?`https://vimeo.com/${film.id}${film.hash?`/${film.hash}`:''}`:film.url;
        const index=this.films.push(film)-1;byKey.set(film.key,index);return index;
      };
      config.videos.forEach(film=>{
        if(film.host==='shopify'){
          const template=this.querySelector(`template[data-film-hosted="${film.id}"]`);
          film.element=template?.content.querySelector('video');
          film.url=film.element?.querySelector('source[type="video/mp4"]')?.src || film.element?.querySelector('source')?.src;
          if(!film.element || !film.url)return;
          film.key=`file:${film.url.split('?')[0]}`;
        }
        add(film);
      });
      const replaceEmbed=(element,index)=>{
        const button=document.createElement('button');button.type='button';button.className='doi-film-jump';
        button.textContent=`${this.filmLabels.watch}: ${this.films[index].title}`;
        button.addEventListener('click',()=>{this.selectFilm(index,true);this.jumpToFilms();},options);
        element.replaceWith(button);
      };
      body?.querySelectorAll('iframe').forEach(frame=>{
        const film=identify(frame.getAttribute('src') || frame.getAttribute('data-src'));
        if(!film)return;
        film.title=frame.getAttribute('title');
        if(!film.title || /^(youtube|vimeo)( video)?( player)?$/i.test(film.title))film.title='';
        replaceEmbed(frame,add(film));
      });
      body?.querySelectorAll('video').forEach(video=>{
        const url=video.currentSrc || video.getAttribute('src') || video.querySelector('source[type="video/mp4"]')?.src || video.querySelector('source')?.src;
        if(!url)return;
        const index=add({host:'shopify',id:url,key:`file:${url.split('?')[0]}`,url,element:video.cloneNode(true),poster:video.poster,title:video.getAttribute('aria-label')||video.getAttribute('title')});
        video.pause();replaceEmbed(video,index);
      });
      if(!this.films.length)return;
      this.filmSection=this.querySelector('[data-films]');
      this.filmSection.hidden=false;
      this.querySelector('[data-film-count]').textContent=this.filmLabels.count.replace('__count__',this.films.length);
      const playlist=this.querySelector('[data-film-playlist]');
      this.films.forEach((film,index)=>{
        const button=document.createElement('button');button.type='button';button.className='doi-films__item';button.dataset.filmIndex=index;button.setAttribute('aria-pressed','false');
        button.setAttribute('aria-label',`${this.filmLabels.play}: ${film.title}`);
        if(film.poster){const image=document.createElement('img');image.src=film.poster;image.alt='';image.loading='lazy';image.width=320;image.height=180;button.append(image);}
        const text=document.createElement('span'),title=document.createElement('strong'),state=document.createElement('small');
        title.textContent=film.title;state.textContent=this.filmLabels.play;state.dataset.filmState='';text.append(title,state);button.append(text);
        button.addEventListener('click',()=>this.selectFilm(index,true),options);playlist.append(button);
      });
      if(this.films.length===1){playlist.hidden=true;this.querySelector('.doi-films__layout').classList.add('doi-films__layout--single');}
      this.querySelectorAll('[data-films-jump]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>this.jumpToFilms(),options);});
      // Keep the theme's legacy YouTube link handler away from this component.
      this.querySelector('[data-film-source]').addEventListener('click',event=>event.stopImmediatePropagation(),{...options,capture:true});
      this.querySelector('[data-film-stop]').addEventListener('click',()=>{this.selectFilm(this.filmIndex,false);this.querySelector('[data-film-stage] button')?.focus({preventScroll:true});},options);
      this.selectFilm(0,false);
    }
    jumpToFilms(){
      this.filmSection?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
      this.querySelector('[data-film-stage] button, [data-film-stage] iframe, [data-film-stage] video')?.focus({preventScroll:true});
    }
    selectFilm(index,play){
      const film=this.films[index];if(!film)return;
      this.filmIndex=index;
      const stage=this.querySelector('[data-film-stage]');
      stage.querySelector('video')?.pause();stage.replaceChildren();
      this.querySelector('[data-film-title]').textContent=film.title;
      const source=this.querySelector('[data-film-source]');
      source.href=film.url;source.textContent=film.host==='youtube'?this.filmLabels.youtube:film.host==='vimeo'?this.filmLabels.vimeo:this.filmLabels.open;
      this.querySelectorAll('[data-film-index]').forEach(button=>{
        const selected=Number(button.dataset.filmIndex)===index;button.setAttribute('aria-pressed',String(selected));
        button.querySelector('[data-film-state]').textContent=this.filmLabels.play;
      });
      this.querySelector('[data-film-status]').textContent=film.title;
      this.querySelector('[data-film-stop]').hidden=!play;
      if(play){
        if(film.host==='shopify'){
          const video=film.element.cloneNode(true);video.controls=true;video.autoplay=true;video.loop=false;video.muted=false;video.playsInline=true;video.preload='metadata';video.setAttribute('aria-label',film.title);stage.append(video);video.play().catch(()=>{});
        } else {
          const iframe=document.createElement('iframe');
          const url=new URL(film.host==='youtube'?`https://www.youtube-nocookie.com/embed/${film.id}`:`https://player.vimeo.com/video/${film.id}`);
          url.searchParams.set('autoplay','1');url.searchParams.set('playsinline','1');
          if(film.host==='youtube')url.searchParams.set('rel','0');
          if(film.hash)url.searchParams.set('h',film.hash);
          iframe.src=url.href;iframe.title=film.title;iframe.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';stage.append(iframe);
        }
      } else {
        const button=document.createElement('button');button.type='button';button.className='doi-films__poster';button.setAttribute('aria-label',`${this.filmLabels.play}: ${film.title}`);
        if(film.poster){
          const image=document.createElement('img');image.alt='';image.loading='lazy';image.width=1280;image.height=720;
          image.src=film.poster;
          if(film.host==='youtube'){
            // Show the existing thumbnail immediately; a slow provider must not leave a blank poster.
            const highResolution=new Image();
            highResolution.onload=()=>{if(highResolution.naturalWidth>=640)image.src=highResolution.src;};
            highResolution.src=`https://i.ytimg.com/vi/${film.id}/maxresdefault.jpg`;
          }
          button.append(image);
        }
        const label=document.createElement('span');label.className='doi-films__play';
        label.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m8 4 13 8-13 8Z"/></svg>';
        label.append(document.createTextNode(this.filmLabels.play));button.append(label);
        button.addEventListener('click',()=>{this.selectFilm(index,true);stage.querySelector('iframe,video')?.focus({preventScroll:true});},{signal:this.abort.signal});stage.append(button);
      }
    }

    disconnectedCallback(){if(this.dialog?.open)document.documentElement.classList.remove('doi-photo-viewer-open');this.querySelector('[data-film-stage] video')?.pause();this.querySelector('[data-film-stage]')?.replaceChildren();this.querySelector('[data-film-playlist]')?.replaceChildren();this.abort?.abort();this.started=false;this.querySelector('[data-toc-list]')?.replaceChildren();}
    changePhoto(direction){this.photoIndex=(this.photoIndex+direction+this.config.photos.length)%this.config.photos.length;this.showPhoto();}
    showPhoto(){
      const photo=this.config.photos[this.photoIndex];if(!photo)return;
      this.dialog.classList.remove('doi-entry__dialog--video');
      const image=document.createElement('img');image.src=photo.url;image.alt=photo.alt;image.decoding='async';
      this.querySelector('[data-dialog-media]').replaceChildren(image);
      this.querySelector('[data-photo-count]').textContent=this.config.count.replace('__number__',String(this.photoIndex+1));
      this.querySelector('[data-photo-caption]').textContent=photo.alt;
      this.querySelector('[data-previous]').hidden=this.config.photos.length<2;
      this.querySelector('[data-next]').hidden=this.config.photos.length<2;
    }
  }
  customElements.define('doi-entry',DoiEntry);
}
